import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} || 𝝠nimus </title>
                    <meta name="description" content="𝝠nimus" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
